import { Component, OnInit, OnDestroy, Input,AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkInfoService } from '../../../_services/index';
import { AuthenticationService } from '../../../_services/index';


@Component({
  selector: 'app-employment',
  templateUrl: './employment.component.html',
  styleUrls: ['./employment.component.css'],
  providers:[WorkInfoService]
  
})
export class EmploymentComponent implements OnInit, OnDestroy {

  employmentForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  formValueChangeSub: Subscription;
  date: any[] = [ /\d/, /\d/,'-', /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];
  public validYear = [/[1-9]/, /\d/, /\d/, /\d/]
  
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  public personalEmail: string;
  currentUser:any;
  loading: boolean;
  public checkChange = false;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  public checkboxes = [];
  public checkboxesArray = [];
  public showBelow = false;
  public isRequired = false;
  public isEng:boolean=false;
  public isInfoAbtMny:boolean=false;
  public isRecTANF:boolean=false;
  public programs = [];
  public programArray = [];
  public isLivedCal:boolean=true;
  public isSpouseFullTEmp:boolean=false;
  public isCredFullTEmp:boolean=false;
  public isEmpAsSeasnl:boolean=false;
  public isCrtOrdrFstr:boolean=false;
  public cares = [];
  public caresArray = [];
  public isDecRes:boolean=false;
  public years = [];
  public isRegToVote:boolean=false;
  public isDecResOutOfState:boolean=false;
  public isPetLawSuit:boolean=false;
  isCNIC = false;
  
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    public api: WorkInfoService,
    private loginservice: AuthenticationService,
    
  ) { }

  ngOnInit() {
    
    //this.getAcademicInfo();

    this.checkboxes = [
                  {'id':'1','Name':'Agriculture & Natural Resources','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'2','Name':'Arts, Media & Entertainment','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'3','Name':'Building & Construction Technologies','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'4','Name':'Business & Finance','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'5','Name':'Education','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'6','Name':'Energy, Environment and Utilities','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'7','Name':'Engineering & Architecture','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'8','Name':'Fashion & Interior Design','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'9','Name':'Health Sciences & Medical Technology','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'10','Name':'Hospitality, Tourism & Recreation','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'11','Name':'Information & Communication Technologies','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'12','Name':'Manufacturing & Product Development','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'13','Name':'Marketing, Sales & Services','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'14','Name':'Public Services','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                  {'id':'15','Name':'Transportation','isChosen': false,'year':'','organization':'','role':'','hidden': true,'required': null},
                
                ];
    
    for (let checkbox of this.checkboxes) {
      this.checkboxesArray.push(this._fb.group({
        isChosen: checkbox.isChosen,
        name: checkbox.Name,
        typeArray:this._fb.array([ this.createType() ]),

        /* year: checkbox.year,
        organization: checkbox.organization,
        role: checkbox.role, */
        hidden: checkbox.hidden,
        //required: checkbox.required
      }));
    }

    this.programs = [
      {'name': 'Academic counseling/advising', 'isChosen':false},
      {'name': 'Basic skills (reading, writing, math)', 'isChosen':false},
      {'name': 'CalWorks', 'isChosen':false},
      {'name': 'Career planning', 'isChosen':false},
      {'name': 'Child care', 'isChosen':false},
      {'name': 'Counseling - personal', 'isChosen':false},
      {'name': 'DSPS - Disabled Student Programs and Services', 'isChosen':false},
      {'name': 'EOPS - Extended Opportunity Programs and Services', 'isChosen':false},
      {'name': 'ESL - English as a Second Language', 'isChosen':false},
      {'name': 'Health services', 'isChosen':false},
      {'name': 'Housing information', 'isChosen':false},
      {'name': 'Employment assistance', 'isChosen':false},
      {'name': 'Online classes', 'isChosen':false},
      {'name': 'Re-entry program (after 5 years out)', 'isChosen':false},
      {'name': 'Scholarship information', 'isChosen':false},
      {'name': 'Student government', 'isChosen':false},
      {'name': 'Testing, assessment, orientation', 'isChosen':false},
      {'name': 'Transfer information', 'isChosen':false},
      {'name': 'Tutoring services', 'isChosen':false},
      {'name': 'Veterans services', 'isChosen':false}
    ];

    for (let chkbx of this.programs) {
      this.programArray.push(this._fb.group({
        isChosen: chkbx.isChosen,
        name: chkbx.name,
      }));
    }

    // this.cares = [
    //   {'name': 'I am currently in foster care (including extended foster care after age 18).', 'isChosen':false},
    //   {'name': 'I aged out/emancipated from foster care or exited voluntarily on or after my 18th birthday.', 'isChosen':false},
    //   {'name': 'I exited the foster care system before my 18th birthday.', 'isChosen':false},
    //   {'name': 'I am not sure at what age I exited foster care.', 'isChosen':false},
    // ];

    // for (let car of this.cares) {
    //   this.caresArray.push(this._fb.group({
    //     isChosen: car.isChosen,
    //     name: car.name,
    //   }));
    // }

    this.years = [
      {'year': 2016},
      {'year': 2017},
      {'year': 2018}
    ];

    //console.log(this.hobbiesArray);
    
    this.createForm();

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail=this.currentUser?this.currentUser.email:'';
    this.employmentForm.get('personalEmail').setValue(this.personalEmail);

    this.getExtraInfo();
    
    window.scrollTo(300, 500);
    this.checkCinc();
  }

  ngOnDestroy() {
    
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if(this.formValueChangeSub){
      this.formValueChangeSub.unsubscribe();
    }
        
  }

  createType() {
    return this._fb.group({
      year: [''],
      organization: [''],
      role: [''],
    });
  }

  addType(i: number) {
    //console.log(i);
    //console.log(this.extraForm.controls['involved']['controls'][i].controls['typeArray']);
    const control = <FormArray>this.employmentForm.controls['industry']['controls'][i].controls['typeArray'];
    control.push(this.createType());
  }

  deleteType(i: number,x: number) {
    //console.log(this.extraForm.controls['involved']['controls'][i].controls['typeArray']);
    const control = <FormArray>this.employmentForm.controls['industry']['controls'][i].controls['typeArray'];
    control.removeAt(x);
  }

  createForm()  {

    let formControlArray = new FormArray(this.checkboxesArray);
    let formControlProgramsArray = new FormArray(this.programArray);

    if (this.isCNIC) {

        this.employmentForm  = this._fb.group({
          personalEmail: ['', [Validators.required]],
          industry: formControlArray,
          selectedItems: [''],      
          employedpast: [''],
          switch:['',[Validators.required]],
          eng:['',[Validators.required]],
          infoAbtMny: ['',[Validators.required]],
          recTANF: ['',[Validators.required]],
          intrestedInSport: ['intrestedInOneOrMore'],
          programs: formControlProgramsArray,
          programSelectedItem: new FormControl(this.mapProgItems(formControlProgramsArray.value), Validators.required),
          livedcal: ['', [Validators.required]],
          stayBegin: [''],
          notArrivedCal: [''],
          spouseFullTEmp: ['',[Validators.required]],
          credFullTEmp: ['',[Validators.required]],
          empAsSeasnl: ['',[Validators.required]],
          crtOrdrFstr: ['',[Validators.required]],
          cares: ['iAmCurrInFoster'],
          // caresSelectedItem: [''],
          decRes: ['',[Validators.required]],
          decResRecYear: ['2016'],
          regToVote: ['',[Validators.required]],
          regToVoteRecYear: ['2016'],
          decResOutOfState: ['',[Validators.required]],
          decResOutOfStateYear: ['2016'],
          petLawSuit: ['',[Validators.required]],
          petLawSuitYear: ['2016'],
        });

    } else {
      this.employmentForm  = this._fb.group({
        personalEmail: ['', [Validators.required]],
        industry: formControlArray,
        selectedItems: [''],      
        employedpast: [''],
        switch:['',[Validators.required]],
        eng:[''],
        infoAbtMny: [''],
        recTANF: [''],
        intrestedInSport: ['intrestedInOneOrMore'],
        programs: formControlProgramsArray,
        programSelectedItem: new FormControl(this.mapProgItems(formControlProgramsArray.value)),
        livedcal: [''],
        stayBegin: [''],
        notArrivedCal: [''],
        spouseFullTEmp: [''],
        credFullTEmp: [''],
        empAsSeasnl: [''],
        crtOrdrFstr: [''],
        cares: ['iAmCurrInFoster'],
        // caresSelectedItem: [''],
        decRes: [''],
        decResRecYear: [''],
        regToVote: [''],
        regToVoteRecYear: ['2016'],
        decResOutOfState: [''],
        decResOutOfStateYear: ['2016'],
        petLawSuit: [''],
        petLawSuitYear: ['2016'],
      });

    }

    this.formChangeSub = this.employmentForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

    this.formValueChangeSub = formControlArray.valueChanges.subscribe((v) => {
      //console.log(v);
      this.mapItems(v);
    });

    formControlProgramsArray.valueChanges.subscribe((v) => {
      this.employmentForm.controls.programSelectedItem.setValue(this.mapProgItems(v));
    });

  }

  mapItems(items) {
    
     let selectedItems = items.filter(x => x.isChosen);
     
     this.employmentForm.controls.selectedItems.setValue(selectedItems.length>0?selectedItems.length:null);
   
  }

  mapProgItems(items) {
    let programSelectedItem = items.filter(x => x.isChosen);
    return programSelectedItem.length ? programSelectedItem : null;
  }

  private _onValueChanged() {

    //console.log(this.employmentForm.controls.employedpast.value);

    let val = this.employmentForm.controls.switch.value;
    
    if(val == '' || val == '1') {
      //console.log('dw');
      this.isRequired = null;
      
    } else {
      //console.log('qqdw');
      
      this.isRequired = false;
      
    }
    
    //console.log(this.employmentForm.controls.selectedItems.value)
    
    if(this.checkChange)
    {

      this.valueChange = true

    }
        
  }

  onCheckChange() {
    
    let items = this.employmentForm.value;

    //console.log(items.involved)

    let length = items.industry.filter(x => x.isChosen).length;
    
    //console.log(length);

    items.industry.filter(x => x.name).map(x => {

        //console.log(x.typeArray);

        if(x.isChosen)
        {
          
            x.hidden = false;
            //x.required = null;
            
        } else {

            x.hidden = true;

            x.typeArray.filter(xx => xx.year).map(xx => {

              xx.year = '';
              xx.role = '';
              xx.organization = '';
            
            });
            //x.typeArray = '';
            //x.required = false;
            //x.year = '';
            //x.role = '';
            //x.organization = '';
        }

    });

    //console.log(items.industry);

    this.employmentForm.controls['industry'].setValue(items.industry);
    this.employmentForm.controls.selectedItems.setValue(1);
    
  }

  showVal() {

    let items = this.employmentForm.value;

    //console.log(items)

    let length = items.industry.filter(x => x.isChosen).length;

    items.industry.filter(x => x.isChosen).map(x => {
        
        /* x.hidden = false;
        x.required = null; */
        if(x.name == 'None')
        {
          
          x.hidden = true;
          //x.required = null;
        }
        else{
          x.hidden = false;
          //x.required = null;
          
        }
    });
  }

  showHideIndustry(){

    let isEmployedPast = this.employmentForm.controls.switch.value;
    
    //console.log(isEmployedPast);

    if(isEmployedPast == '1'){
      
      this.showBelow = true;
 
    } else {
      this.showBelow = false;

    }
    //console.log(this.showBelow);
  }

  onSubmit() {
    
    this.loading = true;
    //console.log(this.employmentForm.controls.industry.value);
    
    const body = JSON.stringify({
      personalEmail: this.employmentForm.controls.personalEmail.value,
      employedpast: this.employmentForm.controls.switch.value,
      selectedItems: this.employmentForm.controls.selectedItems.value,      
      industry: JSON.stringify( this.employmentForm.controls.industry.value ),
      eng: this.employmentForm.controls.eng.value,
      infoAbtMny: this.employmentForm.controls.infoAbtMny.value,
      recTANF: this.employmentForm.controls.recTANF.value,
      intrestedInSport: this.employmentForm.controls.intrestedInSport.value,
      programSelectedItem: this.employmentForm.controls.programSelectedItem.value,
      programs: JSON.stringify(this.employmentForm.controls.programs.value),
      isLivedCal: this.employmentForm.controls.livedcal.value,
      stayBeginCal: !this.isLivedCal ? this.employmentForm.controls.stayBegin.value : '',
      notArrivedCal: !this.isLivedCal ? this.employmentForm.controls.notArrivedCal.value : '',
      isSpouseFullTEmp:this.employmentForm.controls.spouseFullTEmp.value,
      isCredFullTEmp: this.employmentForm.controls.credFullTEmp.value,
      isEmpAsSeasnl: this.employmentForm.controls.empAsSeasnl.value,
      isCrtOrdrFstr: this.employmentForm.controls.crtOrdrFstr.value,
      caresSelectedItem: '',
      cares: this.employmentForm.controls.cares.value,
      isDecRes: this.employmentForm.controls.decRes.value,
      decResRecYear: this.employmentForm.controls.decResRecYear.value,
      isRegToVote: this.employmentForm.controls.regToVote.value,
      regToVoteRecYear: this.employmentForm.controls.regToVoteRecYear.value,
      isDecResOutOfState: this.employmentForm.controls.decResOutOfState.value,
      decResOutOfStateYear: this.employmentForm.controls.decResOutOfStateYear.value,
      isPetLawSuit: this.employmentForm.controls.petLawSuit.value,
      petLawSuitYear: this.employmentForm.controls.petLawSuitYear.value
    });

    //console.log(body);

    this.submitting = true;
    this.api.postWorkInfo$(body)
      .subscribe(
        data => {
            this.error = false;
            this.submitting = false;
            const response = JSON.parse(data._body);

            this.errorFlag = false;
            this.successMessage = response.message;
            this.loading = false;
            if(!this.canDeactivateCheck)
            {
              this.checkingSubmit = true;
              //console.log(response);
              if( response.errorFields == 0 )
              {
                this.router.navigate(['/profile/partner-questions']);
              }
              else{
                this.errorFlag = true;
                this.errorMessage = 'Please fill all fields.';
                window.scrollTo(300, 500)
                
              }
            }
            
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
            this.loading = false;
          }
          return false;
        },
      );
  }

  getExtraInfo() {
    
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getWorkInfo(body)
    
      .subscribe(responsedata => {
          //console.log(responsedata.data);
          let workInfodata = responsedata.data;
          console.log(workInfodata);
          if(workInfodata.industry)
          {
              let industry = JSON.parse(workInfodata.industry);

              if(industry)
              {
                //this.employmentForm.controls['industry'].setValue(industry);

                let i = 0;
                industry.forEach(item => {

                  let x = 0;

                  //console.log(item.typeArray);
                  //console.log(item.typeArray.length);
                  if(item.typeArray.length > 0)
                  {
                    
                    for(var ii = 2; ii <= item.typeArray.length; ii++){
                      //console.log('i--'+i)
                      
                      const control = <FormArray>this.employmentForm.controls['industry']['controls'][i].controls['typeArray'];
                      control.push(this.createType());
                      x++
                    }
                    //console.log(x);
                  }
                  
                  //console.log(this.employmentForm.controls['industry']['controls'][i].controls['typeArray']);
                  i++
                });

                this.employmentForm.controls['industry'].setValue(industry);
              
                this.onCheckChange();
                  
              }
          }
          
          if(workInfodata.employed_past)
          {
            this.employmentForm.controls['switch'].setValue(workInfodata.employed_past);
          }

          if (workInfodata.eng != null) {
            this.employmentForm.patchValue({
              eng: workInfodata.eng,
              infoAbtMny: workInfodata.info_abt_mny,
              recTANF: workInfodata.rec_tanf,
              intrestedInSport: workInfodata.intrstd_in_sport,
              programs: JSON.parse(workInfodata.programs),
              livedcal: workInfodata.is_lived_cal,
              stayBegin: workInfodata.stay_begin_call,
              notArrivedCal: workInfodata.not_arrvd_cal,
              spouseFullTEmp: workInfodata.is_spouse_full_temp,
              credFullTEmp: workInfodata.is_cred_full_tm_emp,
              empAsSeasnl: workInfodata.is_emp_as_seasnl,
              crtOrdrFstr: workInfodata.is_crt_ordr_fstr,
              cares: workInfodata.cares,
              decRes: workInfodata.is_des_rec,
              decResRecYear: workInfodata.dec_res_rec_year,
              regToVote: workInfodata.is_reg_to_vot,
              regToVoteRecYear: workInfodata.reg_to_vot_rec_year,
              decResOutOfState: workInfodata.is_dec_rec_outofstate,
              decResOutOfStateYear: workInfodata.dec_rec_outofstate_year,
              petLawSuit: workInfodata.is_pet_lawsuit,
              petLawSuitYear: workInfodata.pet_lawsuit_year,
            });

            
              if ( workInfodata.is_des_rec == 1) {
                this.isDecRes = true;
              } else {
                this.isDecRes = false
              }
            
              if (workInfodata.is_reg_to_vot == 1) {
                this.isRegToVote = true;
              } else {
                this.isRegToVote = false
              }
            
              if (workInfodata.is_dec_rec_outofstate == 1) {
                this.isDecResOutOfState = true;
              } else {
                this.isDecResOutOfState = false
              }

              if (workInfodata.is_pet_lawsuit == 1) {
                this.isPetLawSuit = true;
              } else {
                this.isPetLawSuit = false
              }
            
            setTimeout(() => {
              this.toggleLivedCal(workInfodata.is_lived_cal);
              this.toggleCrtOrdrFstr(workInfodata.is_crt_ordr_fstr);
            }, 2000);
          }

          

          // if(workInfodata.eng)
          // {
          //   this.employmentForm.controls['eng'].setValue(workInfodata.eng);
          // }
          
          //console.log(JSON.parse(academicInfodata.carrer_sectors.json()));
          
          this.showHideIndustry();
          this.loading = false;
          //this.checkChange = true; 
          setTimeout(()=>{    
            this.checkChange = true;
          },2000);

        });

  }

  canDeactivate() {
    
      //console.log('i am navigating away from prior');

      //console.log(this.valueChange);
      
      if(this.valueChange  && this.checkingSubmit == false)
      {
          if(confirm("Want to save changes?")) {

              this.canDeactivateCheck = true;
              this.onSubmit();

          }
      }
      
      return true;
  }

  handleChange(evt) {
    var target = evt.target;
    //console.log(target.value);
    if(target.value == '1'){
      
      this.showBelow = true;
 
    } else {
      this.showBelow = false;

    }
  }

  toggleEng(evt) {
    if (evt.target.value == 1) {
      this.isEng = true;
    } else {
      this.isEng = false
    }
  }

  toggleInfoAbtMny(evt) {
    if (evt.target.value == 1) {
      this.isInfoAbtMny = true;
    } else {
      this.isInfoAbtMny = false
    }
  }

  toggleRecTANF(evt) {
    if (evt.target.value == 1) {
      this.isRecTANF = true;
    } else {
      this.isRecTANF = false
    }
  }

  checkPrograms() {
    let items = this.employmentForm.value;
    let length = items.programs.filter(x => x.isChosen).length;
    items.programs.filter(x => x.name).map(x => {});
    this.employmentForm.controls['programs'].setValue(items.programs);
    console.log(this.employmentForm.controls['programs']);
  }

  toggleLivedCal(value) {
    if (value == '0') {
      this.isLivedCal = false;
    } else {
      this.isLivedCal = true;
    }
  }

  toggleSpouseFullTEmp(evt) {
    if (evt.target.value == 1) {
      this.isSpouseFullTEmp = true;
    } else {
      this.isSpouseFullTEmp = false
    }
  }

  toggleCredFullTEmp(evt) {
    if (evt.target.value == 1) {
      this.isCredFullTEmp = true;
    } else {
      this.isCredFullTEmp = false
    }
  }

  toggleEmpAsSeasnl(evt) {
    if (evt.target.value == 1) {
      this.isEmpAsSeasnl = true;
    } else {
      this.isEmpAsSeasnl = false
    }
  }

  toggleCrtOrdrFstr(value) {
    if (value == 1) {
      this.isCrtOrdrFstr = true;
    } else {
      this.isCrtOrdrFstr = false
    }
  }

  toggleDecRes(evt) {
    if (evt.target.value == 1) {
      this.isDecRes = true;
    } else {
      this.isDecRes = false
    }
  }

  toggleRegToVote(evt) {
    if (evt.target.value == 1) {
      this.isRegToVote = true;
    } else {
      this.isRegToVote = false
    }
  }

  toggleDecResOutOfState(evt) {
    if (evt.target.value == 1) {
      this.isDecResOutOfState = true;
    } else {
      this.isDecResOutOfState = false
    }
  }

  togglePetLawSuit(evt) {
    if (evt.target.value == 1) {
      this.isPetLawSuit = true;
    } else {
      this.isPetLawSuit = false
    }
  }

  // checkCares() {
  //   let items = this.employmentForm.value;
  //   let length = items.cares.filter(x => x.isChosen).length;
  //   items.cares.filter(x => x.name).map(x => {});
  //   this.employmentForm.controls['cares'].setValue(items.cares);
  // }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
      this.isCNIC = true;
    }
    else{
      this.isCNIC = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/employment/employment.component.ts